/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header"
import Footer from "./footer"
import "./layout.css"
import "normalize.css"
require("typeface-roboto-condensed")
require("typeface-caveat")
require("typeface-shadows-into-light")

const Layout = ({ children, pageTitle, pageSubtitle, id, content }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header
        content={content}
        id={id}
        pageTitle={pageTitle}
        pageSubtitle={pageSubtitle}
        siteTitle={data.site.siteMetadata.title}
      />
      <main>{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
